import React from 'react';
import { Spin } from 'antd';
import './css/CustomSpinner.css';

const CustomSpinner = () => {
  return <Spin className="custom-spin" />;
};

export default CustomSpinner;